import { createGlobalStyle } from 'styled-components'
import {
  mediaMax,
  calculateResponsiveSize,
  calculateMobileResponsiveSize,
} from 'styles/media-queries'

const GlobalStyle = createGlobalStyle`
  :root {
    --blue: #0B6177;
    --light: #EDEDED;
    --black: #212121;
    --mid: #0D6859;
  }
  li {
    list-style: none;
  }
  * {
    margin: 0;
    padding: 0;
    font-family: inherit;
    box-sizing: border-box;
  }
  body {
    width: 100%;
    height: 100%;
    font-family: "Basis Grotesque";
    font-size: ${calculateResponsiveSize(12)};
    font-weight: 300;
    line-height: ${calculateResponsiveSize(19.2)};
    text-align: center;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: var(--light);
    letter-spacing: 0;

    color: var(--black);
   
    min-width: 320px;
    overflow-y: scroll;
    ${mediaMax('mobile')} {
      font-size: ${calculateMobileResponsiveSize(12)};
      line-height: ${calculateMobileResponsiveSize(19.2)};
    }
  }
  body.hidden {
    height: 100dvh !important;
  }
  body.hidden .home-wrapper {
    height: 100dvh;
    overflow: hidden;
  }

  a, a:hover, a:active, a:visited {
    color: var(--blue);
    text-decoration: none;
  }

  .fadeIn {
    transform: translateY(150px);
    opacity: 0;
    transition: all 0.8s ease;
    &.visible {
      transform: translateY(0);
      opacity: 1;
    }
  }

  .imgPallarax{
    overflow: hidden;
    .gatsby-image-wrapper{
      transform: scale(1.3);
      transition: 1s;
    }
    opacity: 0;
    transition: 0.8s;
    &.visible {
      opacity: 1;
      .gatsby-image-wrapper{
        transform: scale(1);
      }
    }
  }

  @keyframes fadeIn {
    0% {
      transform: translateY(-100%);
    }
    100% {
      transform: translateY(0%);
    }
  }

  

  .home-content {
     will-change: transform; 
  }
  .h2{
    font-family: "Canela";
    font-size: ${calculateResponsiveSize(42)};
    font-weight: 250;
    line-height: ${calculateResponsiveSize(50.4)};
    letter-spacing: -0.01em;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    ${mediaMax('mobile')} {}
  }
  .web-only{
    ${mediaMax('mobile')} {
      display: none !important;
    }
  }
  .mob-only{
    display: none !important;
    ${mediaMax('mobile')} {
      display: flex !important;
    }
  }

  #hero,
  #es-hero{
    z-index: 1;
    position: relative;
  }
`

export default GlobalStyle
